/* Polyfill
 ---------------------------------------------------------- */
import './polyfill/_assign'
import './polyfill/_entries'
import './polyfill/_isnan'
import './polyfill/_repeat'
import './polyfill/_for-each'

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from './modules/_navigation'
import ObjectFit from './modules/_object-fit'
import Print from './modules/_print'
import CoverSlider from './modules/_cover-slider'
import CategorySlider from './modules/_category-slider'
import LazyLoad from './modules/_lazy-load'
import StickyPolyfill from './modules/_sticky'
import VideoModal from './modules/_video-modal'
import Tooltip from './modules/_tooltip'
import Modals from './modules/_modal'
import TextImageSliders from './modules/_text-image-slider'
import ScrollAnimations from './modules/_scroll-animations'
import Lightboxes from './modules/_lightboxes'
import SeriesSlider from './modules/_series-slider'
import ProductSlider from './modules/_product-slider'
import Employees from './modules/_employees'
import SmoothScroll from './modules/_smooth-scroll'
import FloatingLabels from './modules/_floating-labels'
import SocialShare from './modules/_social-share'
import Gallery from './modules/_gallery'
import OfferCounter from './modules/_offer-counter'
import ProductCounters from './modules/_product-counters'
import FadeIn from './modules/_fade-in'
import CF7 from './modules/_cf7'
import Faq from './modules/_faq'
import UspImage from './modules/_usp-image'
import SliderTable from 'modules/_slider-table'
import ArticlesArchive from "modules/_articles-archive";

/* Register modules
---------------------------------------------------------- */
new LazyLoad()

window.addEventListener('load', () => {
  Navigation()
  ObjectFit()
  Print()
  CoverSlider()
  CategorySlider()
  StickyPolyfill()
  VideoModal()
  Tooltip()
  Modals()
  TextImageSliders()
  ScrollAnimations()
  Lightboxes()
  SeriesSlider()
  ProductSlider()
  new Employees()
  new SmoothScroll()
  FloatingLabels()
  SocialShare()
  Gallery()
  OfferCounter()
  ProductCounters()
  FadeIn()
  CF7()
  Faq()
  UspImage()
  new SliderTable()
  ArticlesArchive()

  // require('./app')
})
